export default "__VITE_ASSET__C92IS5Aq__"